import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LuminaTesterEntry"] */ "/workspace/src/components/public/lumina-tester-entry.tsx");
